import {
  ChangeDetectionStrategy,
  Component,
  Input,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-progress-steps',
  templateUrl: './progress-steps.component.html',
  styleUrls: ['./progress-steps.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProgressStepsComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProgressStepsComponent implements ControlValueAccessor {
  @Input() steps = ['Draft', 'Review', 'Active'];
  currentStep = 0; // This will now be set by the form control value

  // ControlValueAccessor Interface
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(obj: any): void {
    this.currentStep = obj || 0;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if needed
  }

  baseColor = '#d0eafb'; // Starting color in hex format

  darkenColor(color: string, amount: number): string {
    let [r, g, b] = color.match(/\w\w/g).map((x) => parseInt(x, 16));
    r = Math.max(0, r - amount);
    g = Math.max(0, g - amount);
    b = Math.max(0, b - amount);
    return `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
  }

  getColorForStep(index: number): string {
    const darkenAmount = index * 20; // Adjust the multiplier to control how much darker each step becomes
    return this.darkenColor(this.baseColor, darkenAmount);
  }

  selectStep(index: number): void {
    this.currentStep = index;
    this.onChange(index);
  }
}
